<template>
  <div>
    <!-- <iframe :src="pdfurl" id="iframe" scrolling="yes" frameborder="0"></iframe> -->
    <!-- <div>
      <img :src="imgUrl" alt width="100%" height="auto" />
      <canvas id="the-canvas" style="display: none"></canvas>
    </div>-->
    <!-- <pdf ref="pdf" :src="pdfurl"></pdf> -->
    <!-- <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfurl" :page="i"></pdf> -->
    <!-- <div v-show="loaded">
      <Pdf v-for="index in numPages" :key="index" :src="pdfurl" :page="index" />
    </div>-->
    <!-- <div class="m-vue-pdf">
      <div v-show="loaded">
        <Pdf v-for="index in numPages" :key="index" :src="pdfurl" :page="index" />
      </div>
    </div>-->

    <!-- <embed
      src="https://zjiva.terabits.cn/var/file/child.pdf"
      type="application/pdf"
      width="100%"
      height="1000px"
    />-->
    <object :data="pdfurl" type="application/pdf" width="100%" height="800px"></object>
    <div>
      <el-card class="qianming-container" body-style="padding:0px">
        <vue-esign
          ref="esign"
          :isCrop="isCrop"
          :width="300"
          :height="300"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        ></vue-esign>
        <div class="contro-container">
          <el-button type="danger" @click="handleReset">清空</el-button>
          <el-button type="primary" @click="handleGenerate">确认</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// import Vconsole from 'vconsole'
// import $ from "jquery";

// import pdf from "vue-pdf";
import { getfile, previewpdf } from "../axios/api.js";

// new Vconsole()

export default {
  name: "Qianming",
  // components: {
  //   pdf
  // },
  data() {
    return {
      lineWidth: 6,
      imgUrl: "",
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      isCrop: false,
      caseid: "",
      pdfurl: "",
      numPages: null
    };
  },
  methods: {
    //清空画板..
    handleReset() {
      this.$refs.esign.reset();
      this.resultImg = "";
    },

    // loadPdf() {
    //   this.pdfUrl = Pdf.createLoadingTask(this.pdfUrl);
    //   this.pdfUrl.promise.then(pdf => {
    //     this.$nextTick(() => {
    //       this.numPages = pdf.numPages; // pdf总页数
    //       this.loaded = true;
    //     });
    //   });
    // },

    //生成签名图片..
    handleGenerate() {
      this.$refs.esign
        .generate()
        .then(res => {
          let randnum = Math.random() * 10000000000000;
          randnum = Math.floor(randnum);
          let fileName = "dianziqianming/" + randnum + ".png";
          let file = this.dataURLtoFile(res, fileName);
          console.log(file);
          // const params = {
          //   id: this.caseid,
          //   file: file
          // };
          getfile([this.caseid, file]).then(res => {
            if (res && res.code === 200) {
              console.log(111);
              this.$message.success("签名上传成功");
            }
          });
          // client
          //   .put(fileName, file)
          //   .then(res => {
          //     if (res.url) {
          //       this.resultImg = res.url;
          //     } else {
          //       this.$message.error("文件上传失败");
          //     }
          //   })
          //   .catch(err => {});
        })
        .catch(err => {
          console.log(err);
          this.$message.error("请签名之后提交！");
        });
    },
    //将base64转换为文件..
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    getlist() {
      // console.log(window.location.href);
      let url = window.location.href;
      var _this = this;
      console.log(url);
      let url1 = url.split("=");
      console.log(url1[1]);
      _this.caseid = url1[1];
      previewpdf([_this.caseid]).then(res => {
        if (res && res.code === 200) {
          console.log(res.data);
          _this.pdfurl = "https://videoapi.terabits.cn" + res.data;
          // this.getNumPages();
          console.log(_this.pdfurl);
          // _this.showPdf(_this.pdfurl);
        }
      });
      // $("#iframe").attr("src", $("#iframe").attr("src"));
      // document.getElementById("iframe").contentWindow.location.reload();
    }
    // showPdf(url) {
    //   console.log(212);
    //   let _this = this;
    //   let imgArr = [];
    //   pdfjsLib.workerSrc = "pdf.worker.js";
    //   let loadingTask = pdfjsLib.getDocument(url);
    //   console.log(loadingTask);
    //   // PDFJS.workerSrc = 'pdf.worker.js';// pdfjsLib为undefined可以换成这行
    //   // let loadingTask = PDFJS.getDocument(url);// pdfjsLib为undefined可以换成这行
    //   loadingTask.promise.then(
    //     function(pdf) {
    //       console.log("PDF loaded");
    //       let pageNum = pdf.numPages;
    //       // console.log(pageNum);
    //       for (let i = 1; i <= pageNum; i++) {
    //         pdf.getPage(i).then(function(page) {
    //           console.log("Page loaded");

    //           let scale = 1;
    //           let viewport = page.getViewport(scale);

    //           // let canvas = document.getElementById('the-canvas');
    //           let canvas = document.createElement("canvas");
    //           let context = canvas.getContext("2d");
    //           canvas.height = viewport.height;
    //           canvas.width = viewport.width;

    //           let renderContext = {
    //             canvasContext: context,
    //             viewport: viewport
    //           };
    //           let renderTask = page.render(renderContext);
    //           renderTask.then(function() {
    //             console.log("Page rendered");
    //             let imgUrl = canvas.toDataURL("image/jpeg"); //转换为base64
    //             if (imgUrl) {
    //               imgArr[i - 1] = imgUrl;
    //             }
    //             //pdf全部画完结束后操作
    //             if (imgArr.length == pageNum && !isEmpty(imgArr)) {
    //               // let canvas2 = document.createElement("canvas");
    //               let canvas2 = document.getElementById("the-canvas");
    //               let context2 = canvas2.getContext("2d");
    //               canvas2.height = viewport.height * pageNum;
    //               canvas2.width = viewport.width;
    //               let count = 0;
    //               for (let j = 0; j < imgArr.length; j++) {
    //                 let IMG = new Image();
    //                 IMG.src = imgArr[j];
    //                 IMG.width = viewport.width;
    //                 IMG.height = viewport.height;
    //                 IMG.onload = function() {
    //                   context2.drawImage(IMG, 0, viewport.height * j);
    //                   count++; //确保所有img渲染结束后操作
    //                   if (count == pageNum) {
    //                     let canvas = document.getElementById("the-canvas");
    //                     //赋值给img
    //                     _this.imgUrl = canvas.toDataURL("image/jpeg");
    //                   }
    //                 };
    //               }
    //             }
    //           });
    //         });
    //       }
    //     },
    //     function(reason) {
    //       console.error(reason);
    //     }
    //   );

    //   function isEmpty(arr) {
    //     for (let i = 0; i < arr.length; i++) {
    //       if (!arr[i]) return true;
    //     }
    //     return false;
    //   }
    // }

    // getNumPages() {
    //   console.log(this.pdfurl)
    //   let loadingTask = pdf.createLoadingTask(this.pdfurl);
    //   console.log(loadingTask)
    //   loadingTask.promise
    //     .then(pdf => {
    //       this.numPages = pdf.numPages;
    //     })
    //     .catch(err => {
    //       console.error("pdf 加载失败", err);
    //     });
    // }
  },
  created() {
    this.getlist();
  },
  mounted() {}
};
</script>


<style scoped>
.m-vue-pdf {
  overflow: hidden;
}

#iframe {
  height: 800px;
  width: 100%;
}

button {
  height: 40px;
}
.show-img {
  width: 400px;
  height: 200px;
  border: 1px solid #123456;
}
.show-info {
  width: 400px;
  height: 200px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.contro-container {
  width: 300px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background-color: #d3d3d3;
  position: absolute;
  bottom: 0px;
}
.qianming-container {
  width: 300px;
  height: 350px;
  margin: 20px auto;
  position: relative;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.box-card {
  width: 95%;
  margin-left: 2.5%;
  margin-top: 20px;
}
</style>